import { SelectItem } from 'primeng/api';
import { IsActive } from '../enums';

export class IsActiveLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'All', value: IsActive.All },
            { label: 'Active', value: IsActive.Active },
            { label: 'InActive', value: IsActive.InActive },
        ];
    }
}
